import React from 'react';

import Footer from '~/widgets/footer';
import KeyVisual from '~/widgets/key-visual';
import Header from '~/widgets/navigation/Header';
import Sections from '~/widgets/sections';

import { createLayout } from './Layout';
import { Global } from '@emotion/react';
import { css } from '../css';

const GameSiteLayout: React.FC = () => (
  <>
    <Global styles={GlobalCSS} />
    <Header />
    <KeyVisual />
    <Sections />
    <Footer />
  </>
);

export default createLayout(GameSiteLayout);

const GlobalCSS = css({
  '.view-pc': {
    display: ['none', 'block'],
  },
  '.view-mobile': {
    display: ['block', 'none'],
  },
});
